// [NOTE]
// datadogRum.initは他のpluginなどよりも先に実行されるように注意する必要がある。
// datadogRumはfetch関数を上書きするが、supabaseClientなどはfetchを初期化したクライアント内に保持するため、
// supabaseClientを初期化した後にdatadogRumを初期化をしてもsupabaseClient内に保持されたfetch関数の監視ができない。
// ファイル名を01.datadogRum.client.tsとして最初に実行されるようにしている。
import { datadogRum } from '@datadog/browser-rum'
import { safeStringify } from '@workspace/utils/safeStringify'

import { useAppEnv } from '~/composables/useAppEnv'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const { isProduction, isStaging } = useAppEnv()
  const { applicationId, clientToken, service, version } = config.public.datadogRum

  if (!isProduction && !isStaging) return

  // Datadog上は各サービスprd, stgで統一している
  // Teachme Checkで使うenv名も省略形に寄せて良いかも
  const datadogEnv = (() => {
    if (isProduction) {
      return 'prd'
    }
    if (isStaging) {
      return 'stg'
    }
    return 'unknown'
  })()

  datadogRum.init({
    applicationId,
    clientToken,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'ap1.datadoghq.com',
    service,
    env: datadogEnv,
    version,
    // sessionSampleRateはコストを見ながら調整する
    sessionSampleRate: 100,
    // SessionReplayは不要であれば0にする
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'mask',
    // UI上のテキスト情報が収集されないようにする
    enablePrivacyForActionName: true,
  })

  nuxtApp.hook('vue:error', (err: unknown) => {
    // addError() の型は unknown だが、スタックトレースがないと Error Tracking に表示されないため Error 化する
    // "Favor sending a Javascript Error to have a stack trace attached to the error event."
    // see https://datadoghq.dev/browser-sdk/interfaces/_datadog_browser-rum.DatadogRum.html#addError
    const error = err instanceof Error ? err : new Error(safeStringify(err))
    datadogRum.addError(error)
  })
})
